<template>
  <div class="ima-shopping-cart-overview-modal">

    <form @submit.prevent="onConfirm" class="ima-shopping-cart-overview-modal__form">
      <div class="columns">
        <div class="column">
          <b-field label="Name*">
            <b-input v-model="name" required>
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="E-Mail*">
            <b-input type="email" v-model="email" required>
            </b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
        <b-checkbox v-model="isKesselTour">
                Bestellung gehört zu einer Kesseltour
            </b-checkbox>
        </div>
      </div>
      <div class="columns" v-if="isKesselTour">
        <div class="column">
          <b-field label="Kesseltour-Nr.*">
            <b-input v-model="tourNumber" required>
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Kostenstelle*">
            <b-input v-model="costCenter" required>
            </b-input>
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
        <b-checkbox v-model="isDirectCustomerDelivery">
                Bestellung direkt an den Kunden
            </b-checkbox>
        </div>
      </div>
      <div v-if="isDirectCustomerDelivery" class="columns ima-shopping-cart-overview-modal__address-form">
        <div class="column">
          <strong>Lieferadresse</strong>
          <ima-address-form v-model="shippingAddress"/>
        </div>
        <div class="column ima-shopping-cart-overview-modal__copy-column">
          <button type="button" class="button is-success" @click="onAddressCopy">
            <b-icon icon="arrow_forward"></b-icon>
          </button>
        </div>
        <div class="column">
          <strong>Rechnungsadresse</strong>
          <ima-address-form v-model="invoiceAddress"/>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <b-field label="Tel.-Nr. bei Rückfragen">
            <b-input v-model="phone" type="tel" :required="isDirectCustomerDelivery">
            </b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Wunschtermin">
      <flat-pickr v-model="date" :config="dateConfig"></flat-pickr>
          </b-field>
        </div>
      </div>

      <article class="message is-info">
        <div class="message-header">
          Schilder-Übersicht
          </div>
      <div class="message-body">
      <ul>
        <li v-for="item in shoppingCart.data" :key="item.sign.id">
          {{item.amount}} x {{item.sign.name}} (ID: {{item.sign.id}}) - Typ: {{item.sign.signType.name}}
        </li>
      </ul>
      </div>
      </article>

      <b-field label="Anmerkungen">
        <b-input maxlength="256" type="textarea" v-model="comment"></b-input>
      </b-field>

      <article class="message is-info">
        <div class="message-body">
            <p>Kosten pro Schild: 7,00€ (gem. Vertragsposition 7.1) <br/>
            Fracht	u.	Verpackungspauschale in	Deutschland: 9 € <br/>
            Auslandssendungen	werden	gesondert	angeboten.</p>
        </div>
      </article>

      <div class="field">
        <b-checkbox v-model="hasConfirmedTerms">
          Mir ist bewusst dass mir durch das verbindliche Absenden der Bestellung Kosten entstehen.
        </b-checkbox>
      </div>



    <div :style="{'text-align': 'right'}">

      <button type="submit" class="button is-success" :class="{'is-loading' : shoppingCart.isSaving}" :disabled="!isValidForm || shoppingCart.isSaving">
        <b-icon icon="send"></b-icon>
        <span>Kostenpflichtig bestellen
        </span>
      </button>
      <button type="button" class="button is-danger" @click="onCancel" :disabled="shoppingCart.isSaving">Abbrechen</button>
    </div>
    </form>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'

import inform from '@/services/inform'
import { closeModals } from '@/store/modules/modals'
import { submitOrder } from '@/store/modules/shopping-cart'
import AddressForm from '@/components/AddressForm'
import flatPickr from 'vue-flatpickr-component'

import modals from '@/mixins/modals'
import dateConfig from '@/util/dateconfig'

export default {
  name: 'ima-shopping-cart-overview-modal',
  components: {
    flatPickr,
    'ima-address-form': AddressForm
  },
  data () {
    return {
      name: null,
      email: null,
      isKesselTour: false,
      tourNumber: null,
      costCenter: null,
      isDirectCustomerDelivery: false,
      invoiceAddress: null,
      shippingAddress: null,
      hasConfirmedTerms: false,
      comment: '',
      phone: null,
      date: null,
      dateConfig
    }
  },
  computed: {
    ...mapState(['user', 'shoppingCart']),
    isValidForm () {
      const isValidAddress = (address) => {
        const { company, street, streetNumber, zip, city, country } = address
        return !!(company && street && streetNumber && zip && city && country)
      }

      if (this.isKesselTour && (!this.tourNumber || !this.costCenter)) {
        return false
      }

      if (this.isDirectCustomerDelivery && (!this.phone || !isValidAddress(this.invoiceAddress) || !isValidAddress(this.shippingAddress))) {
        return false
      }

      return (
        this.hasConfirmedTerms &&
        this.name &&
        this.email
      )
    }
  },
  mixins: [modals],
  methods: {
    ...mapMutations([closeModals]),
    ...mapActions([submitOrder]),
    onConfirm () {
      let { shippingAddress, invoiceAddress, tourNumber, costCenter } = this
      const { name, email, comment, phone, date } = this

      // Remove data in case had this entered before toggling
      if (!this.isDirectCustomerDelivery) {
        shippingAddress = null
        invoiceAddress = null
      }

      if (!this.isKesselTour) {
        tourNumber = null
        costCenter = null
      }

      const orderedSigns = this.shoppingCart.data.map(
        ({ amount, sign, variant }) => ({
          amount,
          sign: { id: sign.id, name: sign.name },
          variant: { id: variant.id, name: variant.name }
        })
      )

      this.submitOrder({
        name,
        email,
        tourNumber,
        costCenter,
        orderedSigns,
        comment,
        shippingAddress,
        invoiceAddress,
        phone,
        date
      }).then(() => {
        inform('Bestellung erfolgreich abgeschickt!')
        this.closeModals()
      })
    },
    onCancel () {
      this.closeModals()
    },
    onAddressCopy () {
      this.invoiceAddress = this.shippingAddress
    }
  },
  created () {
    this.name = `${this.user.data.firstName} ${this.user.data.lastName}`
    this.email = this.user.data.email
  }
}
</script>

<style scoped lang="scss">
.ima-shopping-cart-overview-modal {
  &__form {
    margin-bottom: 1rem;

    .field {
      flex-grow: 1;
    }
  }
  &__address-form {
    padding: 0 1rem;
    background: #efefef;
    margin: 0 0 1rem 0;
    border-radius: 3px;


  }
  &__copy-column {
    align-self: center;
    max-width: 4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ShoppingCartOverviewModal.vue